import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../BlockBuilder';
import css from './BlockFooterBrand.module.css';

/**
 * Renders the footer "brand area": logo block + social media links.
 */
const BlockFooterBrand = props => {
  const { className, logoBlock, socialMediaLinks = [], options, sectionId } = props;

  // CUSTOM: Harcode the new two social medias using the correct structure.
const linksAsBlocks = [
  ...socialMediaLinks.map(sml => ({
    ...sml,
    blockType: 'socialMediaLink',
    blockId: sml.link.platform,
    blockName: sml.link.platform,
    platform: sml.link.platform,
    href: sml.link.url,
  })),
  {
    blockType: 'socialMediaLink',
    blockId: 'whatsapp',
    blockName: 'whatsapp',
    link: {
      fieldType: 'socialMediaLink',
      platform: 'whatsapp',
      url: 'https://wa.me/528132568195',
    },
  },
  {
    blockType: 'socialMediaLink',
    blockId: 'email',
    blockName: 'email',
    link: {
      fieldType: 'socialMediaLink',
      platform: 'email',
      url: 'mailto:info@yourcitypartner.com',
    },
  },
];

  return (
    <div className={classNames(css.root, className)}>

      {logoBlock ? (
        <div className={css.logo}>
          <Field data={logoBlock.text} />
        </div>
      ) : null}

      {linksAsBlocks.length > 0 ? (
        <div className={css.icons}>
          <BlockBuilder blocks={linksAsBlocks} sectionId={sectionId} options={options} />
        </div>
      ) : null}
    </div>
  );
};

export default BlockFooterBrand;
